import React from "react";
import BaseDetails from "./baseDetails";

export default function modelDataCreateDetails({ row }) {
    // Object info (ID, Type, Name) is already shown in base details
    return <BaseDetails row={row}>{null}</BaseDetails>;
}
